module.exports = __webpack_public_path__ + "img/icon_qiye02.634de35e.png";